import { render, staticRenderFns } from "./workorderType.vue?vue&type=template&id=d247cdf8"
import script from "./workorderType.vue?vue&type=script&lang=js"
export * from "./workorderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d247cdf8')) {
      api.createRecord('d247cdf8', component.options)
    } else {
      api.reload('d247cdf8', component.options)
    }
    module.hot.accept("./workorderType.vue?vue&type=template&id=d247cdf8", function () {
      api.rerender('d247cdf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/workorder/workorderType.vue"
export default component.exports